import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import axios from "axios";
import { Table } from 'antd';
import Select, { SingleValue } from 'react-select';
import { week_count, allClass, allSection, subjects } from "../../../core/common/selectoption/formselection"
import { ColumnsType } from "antd/es/table";

interface LessonPlanList {
    lessonplan_id: string;
    lesson_title: string;
    subject_name: string;
    class_name: string;
    section_name: string;
    lesson_week: string;
    lesson_date: string;
    teacher_id: string;
    teacher_name: string;
    lessondoc_path: string;
}

const LessonPlanInsert = ({ lessonPlan: initialLessonPlan = [] }: { lessonPlan?: LessonPlanList[] }) => {
    const routes = all_routes;

    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [lesson_title, setLessonTitle] = useState('');
    const [subject_id, setSubjectId] = useState('');
    const [lesson_date, setLessonDate] = useState<Date | null>(null);
    const [lesson_week, setLessonWeek] = useState('');
    const [objectives, setObjective] = useState('');
    const [materials, setMaterials] = useState('');
    const [lesson_summary, setLessonSummary] = useState('');
    const [teacher_id, setTeacherId] = useState('1');
    const [weekCount, setWeekCount] = useState('');
    const [class_Id, setClassId] = useState('');
    const [section_Id, setSectionId] = useState('');
    const [homework_path, setHomeworkpath] = useState<File | null>(null);
    const [lessondoc_path, setLessondocpath] = useState<File | null>(null);
    const [create_by, setCreateBy] = useState('Admin');
    const [update_by, setUpdateBy] = useState('Admin');

    const [teacherIdFind, setTeacherIdFind] = useState('TCH0001');



    const [lessonPlan, setLessonPlan] = useState<LessonPlanList[]>(initialLessonPlan);

    useEffect(() => {

        const fetchLessonPlanByTeacher = async () => {
            try {
                const response = await axios.get(`/api/lessonPlan/getLessonPlanByTeacher/${teacherIdFind}`);
                const dataJson = await response.data;
                console.log('Fetch DATA from BFF: ', dataJson);
                setLessonPlan(dataJson);
            } catch (error) {
                console.error('Error fetching data:', error);
            }

        };

        if (week_count.length > 0) {
            setWeekCount(week_count[0].value);
        } else {
            setWeekCount('');
        }
        if (allClass.length > 0) {
            setClassId(allClass[0].value);
        } else {
            setClassId('');
        }
        if (allSection.length > 0) {
            setSectionId(allSection[0].value);
        } else {
            setSectionId('');
        }
        if (subjects.length > 0) {
            setSubjectId(subjects[0].value);
        } else {
            setSubjectId('');
        }
        fetchLessonPlanByTeacher();
    }, [week_count, allClass, allSection, subjects])

    const handleSubjectChange = (selectedOption: SingleValue<{ value: string; label: string }>) => {
        setSubjectId(selectedOption ? selectedOption.value : '');
    };

    const handleWeekChange = (selectedOption: SingleValue<{ value: string; label: string }>) => {
        setLessonWeek(selectedOption ? selectedOption.value : '');
    };

    const handleClassChange = (selectedOption: SingleValue<{ value: string; label: string }>) => {
        setClassId(selectedOption ? selectedOption.value : '');
    };

    const handleSectionChange = (selectedOption: SingleValue<{ value: string; label: string }>) => {
        setSectionId(selectedOption ? selectedOption.value : '');
    };

    // Function to handle input changes
    // const handleChange = (e: any) => {
    //     const { name, value } = e.target;
    //     setFormData((prevData) => ({
    //         ...prevData,
    //         [name]: value,
    //     }));
    // };

    // Function to handle file uploads
    // const handleFileChange = (e: any) => {
    //     const { name, files } = e.target;
    //     setFormData((prevData) => ({
    //         ...prevData,
    //         [name]: files[0], // Store the uploaded file
    //     }));
    // };

    const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
    const handleApplyClick = () => {
        if (dropdownMenuRef.current) {
            dropdownMenuRef.current.classList.remove("show");
        }
    };

    const handleDateChange = (date: Date | null, fieldName: string) => {
        if (fieldName === 'lesson_date') {
            setLessonDate(date);
            if (date) {
                console.log(`${fieldName} Formatted Date:`, dayjs(date).format('YYYY-MM-DD'));
            } else {
                console.log(`${fieldName} Formatted Date: null`);
            }
        }
    };

    const handleHomeworkDocChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0]; // Get the selected file
        if (file) {
            // Use FileReader to read the file and set it as a preview
            const reader = new FileReader();
            reader.onloadend = () => {
                setHomeworkpath(file); // Set the file in state (for later upload)
            };
            reader.readAsDataURL(file); // Read the file as a data URL
        } else {
            setHomeworkpath(null); // Clear the file in stateß
        }
    };

    const handleLessonDocChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0]; // Get the selected file
        if (file) {
            // Use FileReader to read the file and set it as a preview
            const reader = new FileReader();
            reader.onloadend = () => {
                setLessondocpath(file); // Set the file in state (for later upload)
            };
            reader.readAsDataURL(file); // Read the file as a data URL
        } else {
            setLessondocpath(null); // Clear the file in stateß
        }
    };

    const formattedAdmissionDate = dayjs(lesson_date).format('YYYY-MM-DD');

    // Function to handle form submission
    const lessonSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const lessonFormData = new FormData();
        lessonFormData.append('lesson_title', lesson_title);
        lessonFormData.append('subject_id', subject_id);
        lessonFormData.append('lesson_date', formattedAdmissionDate);
        lessonFormData.append('lesson_week', lesson_week);
        lessonFormData.append('class_id', class_Id);
        lessonFormData.append('section_id', section_Id);
        lessonFormData.append('objective', objectives);
        lessonFormData.append('material', materials);
        lessonFormData.append('lesson_summary', lesson_summary);
        lessonFormData.append('teacher_id', teacher_id);
        if (homework_path) {
            lessonFormData.append('homework_path', homework_path);
        } else {
            lessonFormData.append('homework_path', '');
            console.error("No homework document selected.");
        }
        if (lessondoc_path) {
            lessonFormData.append('lessondoc_path', lessondoc_path);
        } else {
            lessonFormData.append('lessondoc_path', '');
            console.error("No lesson document selected.");
        }
        lessonFormData.append('create_by', create_by);
        lessonFormData.append('update_by', update_by);

        try {
            // Add Student API Call
            const lessonPlanResponse = await axios.post('/api/lessonPlan/addLessonPlan', lessonFormData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            console.log('LessonPlanResponse: ', lessonPlanResponse);
            if (lessonPlanResponse.status === 200 || lessonPlanResponse.status === 201) {
                alert('Lesson plan added successfully');
            } else {
                alert('Lesson plan addition failed');
            }
        } catch (error) {
            alert('Error occurred during submission');
            console.log(error);
        }
    };

    const data = lessonPlan;

    const columns: ColumnsType<LessonPlanList> = [
        {
            title: 'Lesson Title',
            dataIndex: 'lesson_title',
            render: (text: string, lessonList: LessonPlanList) => (
                <span>{lessonList.lesson_title}</span>
            )
        },
        {
            title: 'Subject',
            dataIndex: 'subject_name',
            key: 'subject_name',
        },
        {
            title: 'Class',
            dataIndex: 'class_name',
            key: 'class_name',
        },
        {
            title: 'Section',
            dataIndex: 'section_name',
            key: 'section_name',
        },
        {
            title: 'Lesson Week',
            dataIndex: 'lesson_week',
            key: 'lesson_week',
        },
        {
            title: 'Lesson Date',
            dataIndex: 'lesson_date',
            key: 'lesson_date',
            render: (date) => {
                const formattedDate = new Date(date).toLocaleDateString('en-GB'); // dd/MM/yyyy format
                return formattedDate.replace(/\//g, '-'); // Convert slashes to dashes for dd-MM-yyyy
            }
        },
        {
            title: 'Lesson Plan',
            dataIndex: 'lessondoc_path',
            key: 'lessondoc_path',
            render: (path) => {
                const documentName = path ? path.split('/').pop() : ''; // Extract the document name from the path
                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img
                            //src="/path-to-your-icon/document-icon.png" // Replace with the actual path to your document icon
                            src="/assets/img/icons/document_icon2.gif"
                            alt="Document Icon"
                            style={{ width: '20px', marginRight: '10px' }}
                        />
                        <span>{documentName}</span>
                    </div>
                );
            }
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="d-flex align-items-center justify-content-center">
                    <Link to={`${routes.classLessonPlan}/${record.lessonplan_id}`} className="btn btn-primary btn-sm me-2">
                        <i className="ti ti-edit fs-16"></i>
                    </Link>
                    <Link to="#" className="btn btn-danger btn-sm">
                        <i className="ti ti-trash fs-16"></i>
                    </Link>
                </div>
            ),
        },

    ];
    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content content-two">
                    {/* Page Header */}
                    <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                        <div className="my-auto mb-2">
                            <h3 className="mb-1"> Weekly Lesson Plan</h3>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={routes.teacherDashboard}>Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to={routes.classLessonPlan}>Lesson Plan</Link>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    {/* /Page Header */}
                    <div className="row">
                        <div className="col-md-12">
                            <form onSubmit={lessonSubmit}>
                                <div className="card">
                                    <div className="card-header bg-light">
                                        <div className="d-flex align-items-center">
                                            <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                                                <i className="ti ti-map fs-16" />
                                            </span>
                                            <h4 className="text-dark">New Lesson Plan</h4>
                                        </div>
                                    </div>
                                    <div className="card-body pb-1">
                                        <div className="row">
                                            <div className="col-xxl col-xl-3 col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Lesson Title</label>
                                                    <input type="text" className="form-control"
                                                        value={lesson_title} onChange={(e) => { setLessonTitle(e.target.value); }} />
                                                </div>
                                            </div>

                                            <div className="col-xxl col-xl-3 col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Subject</label>
                                                    <Select
                                                        className="select"
                                                        options={subjects}
                                                        defaultValue={isEdit ? subjects[0] : undefined}
                                                        value={subjects.find(option => option.value === subject_id)}
                                                        onChange={handleSubjectChange}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-xxl col-xl-3 col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Lesson Date</label>
                                                    <div className="input-icon position-relative">
                                                        <DatePicker
                                                            className="form-control datetimepicker"
                                                            value={lesson_date} // use state value
                                                            onChange={(date) => handleDateChange(date, 'lesson_date')}
                                                            format={{
                                                                format: "DD-MM-YYYY",
                                                                type: "mask",
                                                            }}
                                                            placeholder="Select Date"
                                                        />
                                                        <span className="input-icon-addon">
                                                            <i className="ti ti-calendar" />
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-xxl col-xl-3 col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Study Week</label>
                                                    <Select
                                                        className="select"
                                                        options={week_count}
                                                        defaultValue={isEdit ? week_count[0] : undefined}
                                                        value={week_count.find(option => option.value === lesson_week)}
                                                        onChange={handleWeekChange}
                                                    />
                                                </div>
                                            </div>                                       

                                            <div className="col-xxl col-xl-3 col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Class</label>
                                                    <Select
                                                        className="select"
                                                        options={allClass}
                                                        defaultValue={isEdit ? allClass[0] : undefined}
                                                        value={allClass.find(option => option.value === class_Id)}
                                                        onChange={handleClassChange}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-xxl col-xl-3 col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Section</label>
                                                    <Select
                                                        className="select"
                                                        options={allSection}
                                                        defaultValue={isEdit ? allSection[0] : undefined}
                                                        value={allSection.find(option => option.value === section_Id)}
                                                        onChange={handleSectionChange}
                                                    />
                                                </div>
                                            </div>

                                        </div>

                                        <div className="row">
                                            <div className="col-xxl-2 col-xl-2 col-md-4">
                                                <div className="mb-3">
                                                    <label className="form-label">Materials</label>
                                                    <input type="text" className="form-control"
                                                        value={materials} onChange={(e) => { setMaterials(e.target.value); }} />
                                                </div>
                                            </div>                                           

                                            <div className="col-xxl-5 col-xl-5 col-md-4">
                                                <div className="mb-3">
                                                    <label className="form-label">
                                                        Objectives
                                                    </label>
                                                    <textarea
                                                        name="objectives"
                                                        className="form-control"
                                                        value={objectives} onChange={(e) => { setObjective(e.target.value); }}
                                                        style={{ width: "100%" }}
                                                        rows={5}
                                                    />
                                                </div>
                                            </div>                                            

                                            {/* <div className="col-xxl col-xl-3 col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">
                                                        Materials
                                                    </label>
                                                    <textarea
                                                        name="materials"
                                                        value={materials} onChange={(e) => { setMaterials(e.target.value); }}
                                                        style={{ width: "100%", padding: "8px", marginTop: "5px" }}
                                                        rows={5}
                                                    />
                                                </div>
                                            </div> */}

                                            <div className="col-xxl-5 col-xl-5 col-md-4">
                                                <div className="mb-3">
                                                    <label className="form-label">
                                                        Lesson Summary
                                                    </label>
                                                    <textarea
                                                        name="lesson_summary"
                                                        className="form-control"
                                                        value={lesson_summary} onChange={(e) => { setLessonSummary(e.target.value); }}
                                                        style={{ width: "100%" }}
                                                        rows={5}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">                        
                                            <div className="col-lg-6">
                                                <div className="mb-2">
                                                    <div className="mb-3">
                                                        <label className="form-label mb-1">
                                                            Upload Homework
                                                        </label>
                                                        <p>Upload document size of 4MB, Accepted Format PDF, docx and PPT</p>
                                                    </div>
                                                    <div className="d-flex align-items-center flex-wrap">
                                                        <div className="btn btn-primary drag-upload-btn mb-2">
                                                            <i className="ti ti-file-upload me-1" />
                                                            Upload Document
                                                            <input
                                                                type="file"
                                                                className="form-control image-sign"
                                                                name="homework_path"
                                                                onChange={handleHomeworkDocChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-6">
                                                <div className="mb-2">
                                                    <div className="mb-3">
                                                        <label className="form-label mb-1">
                                                            Upload Lesson Plan
                                                        </label>
                                                        <p>Upload document size of 4MB, Accepted Format PDF, docx and PPT</p>
                                                    </div>
                                                    <div className="d-flex align-items-center flex-wrap">
                                                        <div className="btn btn-primary drag-upload-btn mb-2">
                                                            <i className="ti ti-file-upload me-1" />
                                                            Upload Document
                                                            <input
                                                                type="file"
                                                                className="form-control image-sign"
                                                                name="lessondoc_path"
                                                                onChange={handleLessonDocChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text-end mb-3">
                                            <button type="submit" className="btn btn-info me-3">Add Lesson Plan</button>
                                            {/* <button type="button" className="btn btn-light me-3">Cancel</button> */}
                                        </div>
                                    </div>
                                </div>                        
                            </form>
                        </div>


                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
                                <h4 className="mb-3">Class Syllabus</h4>
                                <div className="d-flex align-items-center flex-wrap">
                                    <div className="input-icon-start mb-3 me-2 position-relative">
                                    </div>
                                    <div className="dropdown mb-3 me-2">
                                        <Link
                                            to="#"
                                            className="btn btn-outline-light bg-white dropdown-toggle"
                                            data-bs-toggle="dropdown"
                                            data-bs-auto-close="outside"
                                        >
                                            <i className="ti ti-filter me-2" />
                                            Filter
                                        </Link>
                                        <div className="dropdown-menu drop-width" ref={dropdownMenuRef}>
                                            <form >
                                                <div className="d-flex align-items-center border-bottom p-3">
                                                    <h4>Filter</h4>
                                                </div>
                                                <div className="p-3 border-bottom pb-0">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="mb-3">
                                                                <label className="form-label">Class</label>
                                                                {/* <CommonSelect
                                  className="select"
                                  //options={classSylabus}
                                /> */}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="mb-3">
                                                                <label className="form-label">Section</label>
                                                                {/* <CommonSelect
                                  className="select"
                                  options={classSection}
                                  defaultValue={classSylabus[0]}
                                  
                                /> */}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="mb-3">
                                                                <label className="form-label">Status</label>
                                                                {/* <CommonSelect
                                  className="select"
                                  options={activeList}
                                  defaultValue={activeList[0]}
                                   
                                /> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="p-3 d-flex align-items-center justify-content-end">
                                                    <Link to="#" className="btn btn-light me-3">
                                                        Reset
                                                    </Link>
                                                    <Link
                                                        to="#"
                                                        className="btn btn-primary"
                                                        onClick={handleApplyClick}
                                                    >
                                                        Apply
                                                    </Link>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <div className="dropdown mb-3">
                                        <Link
                                            to="#"
                                            className="btn btn-outline-light bg-white dropdown-toggle"
                                            data-bs-toggle="dropdown"
                                        >
                                            <i className="ti ti-sort-ascending-2 me-2" />
                                            Sort by A-Z
                                        </Link>
                                        <ul className="dropdown-menu p-3">
                                            <li>
                                                <Link
                                                    to="#"
                                                    className="dropdown-item rounded-1 active"
                                                >
                                                    Ascending
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    to="#"
                                                    className="dropdown-item rounded-1"
                                                >
                                                    Descending
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    to="#"
                                                    className="dropdown-item rounded-1"
                                                >
                                                    Recently Viewed
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    to="#"
                                                    className="dropdown-item rounded-1"
                                                >
                                                    Recently Added
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-0 py-3">

                                {/* <Table columns={columns} dataSource={data} Selection={true} />  */}
                                <Table dataSource={data} columns={columns} rowKey="lessonplan_id" />


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LessonPlanInsert;
